/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Last_Active_ResolutionInputs */

const en_task_flow_last_active_resolution = /** @type {(inputs: Task_Flow_Last_Active_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep at least one active resolution.`)
};

const pt_br2_task_flow_last_active_resolution = /** @type {(inputs: Task_Flow_Last_Active_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha ao menos uma resolução ativa.`)
};

/**
* | output |
* | --- |
* | "Keep at least one active resolution." |
*
* @param {Task_Flow_Last_Active_ResolutionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_last_active_resolution = /** @type {((inputs?: Task_Flow_Last_Active_ResolutionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Last_Active_ResolutionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_last_active_resolution(inputs)
	return pt_br2_task_flow_last_active_resolution(inputs)
});